// extracted by mini-css-extract-plugin
export var layout = "profile-module--layout--25mC2";
export var desktopBack = "profile-module--desktop-back--1Yu25";
export var hero = "profile-module--hero--2HJQz";
export var menu = "profile-module--menu--2oDIV";
export var left = "profile-module--left--1pC60";
export var copy = "profile-module--copy--3XxYG";
export var mobileBack = "profile-module--mobile-back--33qO2";
export var page = "profile-module--page--1EpKS";
export var section = "profile-module--section--bLu0P";